module.exports = __webpack_public_path__ + "assets/img/title-bg-3.828429b7.png";